export const transportOptions = [
  { key: 'udp', label: 'UDP' },
  { key: 'tcp', label: 'TCP' },
  { key: 'tls', label: 'TLS' },
]

export const headerTypeOptions = [
  { key: 'custom', label: 'Custom Header' },
  { key: 'uui', label: 'UUI Header' },
]

// Placeholder bland variables - will be determined later
export const blandVariables = [
  'call_id',
  'caller_id',
  'destination_number',
  'call_duration',
  'call_status',
]
